<template>
    <span>
        <b-navbar variant="light">
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <slot name="left"></slot>
                    <b-nav-form>
                        <b-form-input
                            v-model="listOptions.q"
                            class="mr-2"
                            placeholder="Search"
                            type="search"
                            @keyup.enter.native.prevent="
                                update_table(listOptions)
                            "
                        ></b-form-input>
                        <b-form-select
                            v-model="listOptions.searchField"
                            :options="searchFieldsList"
                            class="mr-2 mpl-2"
                        />

                        <b-button
                            v-b-tooltip
                            class="ml-0 my-2"
                            title="Search"
                            @click="update_table(listOptions)"
                            ><filter-icon
                        /></b-button>
                        <b-button
                            v-if="showClear"
                            id="clear_search"
                            v-b-tooltip
                            class="my-2 my-sm-0"
                            title="Clear Search"
                            variant="danger"
                            @click="reset_table()"
                            ><filter-remove-outline-icon
                        /></b-button>

                        <b-button
                            v-if="allow_query"
                            id="advanced_query"
                            v-b-tooltip
                            :variant="filter_btn_variant"
                            class="my-2 my-sm-0"
                            title="Advanced Query"
                            @click="toggle_query()"
                            ><database-search-icon></database-search-icon
                        ></b-button>

                        <span v-if="downloadOptions" class="mx-2">
                            <b-dropdown class="m-md-2" text="Download">
                                <b-dropdown-item
                                    v-for="download in downloadOptionsWithData"
                                    :key="download.uri"
                                    class="download"
                                >
                                    <o-download-file-button
                                        :filename="download.filename"
                                        :request="listOptions"
                                        :uri="download.uri"
                                        class="font-weight-bold text-decoration-none"
                                        method="get"
                                        variant="link"
                                    >
                                        {{ download.format_name }}
                                    </o-download-file-button>
                                </b-dropdown-item>
                            </b-dropdown>
                        </span>
                    </b-nav-form>

                    <b-button
                        v-if="newTo"
                        :to="newTo"
                        class="my-2 ml-2"
                        tag="router-link"
                        variant="primary"
                        >{{ newButtonText }}</b-button
                    >

                    <slot name="middle"></slot>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto">
                    <slot name="right"></slot>
                    <b-form-select
                        :options="filtersList"
                        :value="selectedFilter"
                        class="mr-2"
                        options-field="None"
                        text-field="name"
                        value-field="code"
                        @input="update_filter"
                    />
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <div v-if="(showing_query && allow_query) || alwaysShowQuery">
            <query-builder
                :meta-data="schema"
                :query-select-options="querySelectOptions"
                :value="the_query"
                @change="query_changed"
            ></query-builder>
        </div>
    </span>
</template>
<script>
import FilterIcon from "vue-material-design-icons/Filter";
import FilterRemoveOutlineIcon from "vue-material-design-icons/FilterRemoveOutline";
import DatabaseSearchIcon from "vue-material-design-icons/DatabaseSearch";
import QueryBuilder from "../../query/component/QueryBuilder";
import { normaliseOptions } from "../../store/store_utils";

export default {
    name: "OListToolbar",
    components: {
        QueryBuilder,
        DatabaseSearchIcon,
        FilterRemoveOutlineIcon,
        FilterIcon,
    },
    data() {
        return {
            show_query: false,
        };
    },
    props: {
        filtersList: {},
        searchFieldsList: {},
        listOptions: {},
        selectedFilter: {},

        newButtonText: { type: String, default: "Create New" },
        newTo: { type: [Object, String], default: null },

        schema: { type: Object, default: null },
        query: { type: Object, default: null },
        alwaysShowQuery: { type: Boolean, default: false },
        querySelectOptions: {
            type: Object,
            default: () => {},
        },

        downloadOptions: { type: Array, default: null },
    },
    computed: {
        showClear() {
            return this.listOptions.q || this.listOptions.searchField;
        },
        allow_query() {
            return this.schema != null;
        },
        the_query() {
            var result = { and: [[null, null]] };
            if (this.listOptions && this.listOptions.query)
                result = this.listOptions.query;

            return result;
        },
        filter_btn_variant() {
            if (this.showing_query) {
                return "info";
            } else {
                return "secondary";
            }
        },
        showing_query() {
            if (this.listOptions) {
                if (this.listOptions.query) {
                    return true;
                }
            }

            return this.show_query;
        },

        downloadOptionsWithData() {
            var params = normaliseOptions(this.listOptions);
            params.query = JSON.stringify(params.query);
            params.qbe = JSON.stringify(params.qbe);
            params.limit = 65535;
            params.offset = 0;

            return _.map(this.downloadOptions, function (option) {
                var result = { ...option };

                params.columns = JSON.stringify(option.fields);

                var get_params = Object.entries(params)
                    .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                    .join("&");
                result.uri = result.uri + "?" + get_params;

                return result;
            });
        },
    },
    methods: {
        reset_table() {
            this.$emit("reset_table");
        },
        update_table(listOptions) {
            this.$emit("options_changed", listOptions);
        },
        update_filter(value) {
            this.$emit("filter_changed", value);
        },
        toggle_query() {
            if (this.showing_query === true) {
                this.query_changed(null);
            }

            this.show_query = !this.show_query;
        },
        query_changed(query) {
            this.listOptions.query = query;

            this.$emit("options_changed", this.listOptions);
        },
    },
};
</script>

<style lang="scss">
.download {
    .dropdown-item {
        padding: 0 !important;
    }
}
</style>
